"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _Fingerprint_instances, _Fingerprint_window, _Fingerprint_userAgent, _Fingerprint_display, _Fingerprint_browserType, _Fingerprint_isMobileDevice;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Fingerprint = void 0;
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-param-reassign */
/* eslint-disable no-bitwise */
/**
 * Created by micaelalopez on 5/25/15.
 */
const ua_parser_js_1 = require("ua-parser-js");
const Utils_1 = require("./Utils");
const Logger_1 = __importDefault(require("./Logger"));
/**
 * Collects the Time Zone information
 * @return {string}
 */
function _timezoneOffset() {
    return (0, Utils_1.stringToMD5)(`${new Date().getTimezoneOffset()}`);
}
/* Main export */
class Fingerprint {
    constructor(browserWindow = window) {
        _Fingerprint_instances.add(this);
        _Fingerprint_window.set(this, void 0);
        __classPrivateFieldSet(this, _Fingerprint_window, browserWindow, "f");
    }
    /**
     * Generates the fingerprint string with all the collected information
     * @return {string}
     */
    fingerprint() {
        const userAgent = __classPrivateFieldGet(this, _Fingerprint_instances, "m", _Fingerprint_userAgent).call(this) || "Unknown User gent";
        const display = __classPrivateFieldGet(this, _Fingerprint_instances, "m", _Fingerprint_display).call(this);
        const timezoneOffset = _timezoneOffset();
        const fp = `${(0, Utils_1.stringToMD5)(userAgent)}-${(0, Utils_1.stringToMD5)(__classPrivateFieldGet(this, _Fingerprint_instances, "m", _Fingerprint_display).call(this))}-${(0, Utils_1.stringToMD5)(_timezoneOffset())}`;
        Logger_1.default.debug("Generated fingerprint:", fp, "from data:", { userAgent, display, timezoneOffset });
        return fp;
    }
    /**
     * Generates the facet with the browser info
     * @return {BrowserFacet}
     */
    browserFacet() {
        return {
            type: __classPrivateFieldGet(this, _Fingerprint_instances, "m", _Fingerprint_browserType).call(this),
            user_agent: __classPrivateFieldGet(this, _Fingerprint_instances, "m", _Fingerprint_userAgent).call(this).replace(";", ","),
            platform: __classPrivateFieldGet(this, _Fingerprint_window, "f").navigator.platform,
            cookie_enabled: __classPrivateFieldGet(this, _Fingerprint_window, "f").navigator.cookieEnabled,
            online: __classPrivateFieldGet(this, _Fingerprint_window, "f").navigator.onLine,
            language: Array.from(new Set(__classPrivateFieldGet(this, _Fingerprint_window, "f").navigator.languages).add(__classPrivateFieldGet(this, _Fingerprint_window, "f").navigator.language)),
        };
    }
    /**
     * Generates the facet with the device info
     * @return {DeviceFacet}
     */
    deviceFacet() {
        const { os, cpu } = (0, ua_parser_js_1.UAParser)(__classPrivateFieldGet(this, _Fingerprint_instances, "m", _Fingerprint_userAgent).call(this));
        const deviceFacet = Object.assign(Object.assign(Object.assign({ hw_proc: `${__classPrivateFieldGet(this, _Fingerprint_window, "f").navigator.hardwareConcurrency}-Core`, hw_form: __classPrivateFieldGet(this, _Fingerprint_instances, "m", _Fingerprint_isMobileDevice).call(this) ? "Mobile" : "Desktop", hw_display: `${__classPrivateFieldGet(this, _Fingerprint_window, "f").screen.width}x${__classPrivateFieldGet(this, _Fingerprint_window, "f").screen.height}`, hw_input: [`maxTouchPoints:${__classPrivateFieldGet(this, _Fingerprint_window, "f").navigator.maxTouchPoints}`] }, (os.name ? { os_name: os.name } : undefined)), (os.version ? { os_version: os.version } : undefined)), (cpu.architecture ? { os_type: cpu.architecture } : undefined));
        if ("deviceMemory" in __classPrivateFieldGet(this, _Fingerprint_window, "f").navigator) {
            deviceFacet.hw_ram = `${__classPrivateFieldGet(this, _Fingerprint_window, "f").navigator.deviceMemory}GB`;
        }
        return deviceFacet;
    }
}
exports.Fingerprint = Fingerprint;
_Fingerprint_window = new WeakMap(), _Fingerprint_instances = new WeakSet(), _Fingerprint_userAgent = function _Fingerprint_userAgent() {
    return __classPrivateFieldGet(this, _Fingerprint_window, "f").navigator.userAgent;
}, _Fingerprint_display = function _Fingerprint_display() {
    const screen = {};
    const windowScreen = __classPrivateFieldGet(this, _Fingerprint_window, "f").screen;
    // Object.keys() doesn't return anything with window.screen oddly. So here
    // we keep the for..in loop and disable the lint rule.
    // eslint-disable-next-line no-restricted-syntax
    for (const property in __classPrivateFieldGet(this, _Fingerprint_window, "f").screen) {
        if (typeof windowScreen[property] !== "function") {
            screen[property] = windowScreen[property];
        }
    }
    return JSON.stringify(screen);
}, _Fingerprint_browserType = function _Fingerprint_browserType() {
    const ua = __classPrivateFieldGet(this, _Fingerprint_instances, "m", _Fingerprint_userAgent).call(this);
    const M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
        return "IE";
    }
    if (M[1] === "Chrome") {
        if (ua.match(/\bOPR\/(\d+)/) != null) {
            return "Opera";
        }
    }
    return M[1];
}, _Fingerprint_isMobileDevice = function _Fingerprint_isMobileDevice() {
    if ("userAgentData" in __classPrivateFieldGet(this, _Fingerprint_window, "f").navigator) {
        // experimental, not supported by Firefox
        return __classPrivateFieldGet(this, _Fingerprint_window, "f").navigator.userAgentData.mobile;
    }
    // note that mobile device detection is flaky at best
    // recommendation at https://developer.mozilla.org/en-US/docs/Web/HTTP/Browser_detection_using_the_user_agent#mobile_tablet_or_desktop
    // as of Aug 2023
    return /mobi/i.test(__classPrivateFieldGet(this, _Fingerprint_instances, "m", _Fingerprint_userAgent).call(this));
};
